(() => {
  if (window.foodforCartNewsletterInstalled) return;
  window.foodforCartNewsletterInstalled = true;
  let host;
  let pending = false;
  function sync() {
    pending = false;
    const drawer = document.getElementById('CartDrawer');
    document.documentElement.classList.toggle('foodfor-cart-is-open', !!drawer && !drawer.hidden);
    if (!drawer) return;
    const cartSlot = drawer.querySelector('[data-foodfor-newsletter-slot="cart"]');
    const offersSlot = drawer.querySelector('[data-foodfor-newsletter-slot="offers"]');
    if (!cartSlot && !offersSlot) return;
    const fresh = drawer.querySelector('[data-foodfor-newsletter-host]');
    if (!host || (fresh && fresh.dataset.formId !== host.dataset.formId)) host = fresh;
    if (!host) return;
    const offersActive = offersSlot?.closest('.drawer__panel')?.hasAttribute('open');
    const target = offersActive ? offersSlot : cartSlot;
    if (!target) return;
    // Keep the actual rendered form node, including entered values, across cart updates.
    drawer.querySelectorAll('[data-foodfor-newsletter-host]').forEach(node => {
      if (node !== host) node.remove();
    });
    if (host.parentNode !== target) target.appendChild(host);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(sync);
  }
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['open', 'aria-expanded', 'hidden']
  });
  sync();
})();
